import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { SharedModule } from 'src/app/shared/shared.module'

import * as fromStoredPayMethod from './stored-pay-method.reducer'
import { StoredPayMethodRoutingModule } from './stored-pay-method-routing.module'
import { StoredPayMethodEffects } from './stored-pay-method.effects'
import { StoredPayMethodSerializer } from './stored-pay-method.serializer'
import { StoredPayMethodService } from './stored-pay-method.service'

@NgModule({
  imports: [
    CommonModule,
    StoredPayMethodRoutingModule,
    SharedModule,
    StoreModule.forFeature(
      fromStoredPayMethod.FEATURE_NAME,
      fromStoredPayMethod.storedPayMethodReducer
    ),
    EffectsModule.forFeature([StoredPayMethodEffects])
  ],
  declarations: [],
  providers: [
    StoredPayMethodService,
    {
      provide: StoredPayMethodSerializer,
      useClass: StoredPayMethodSerializer
    }
  ]
})
export class StoredPayMethodModule {}
